const RECRUIT_ROUTES = {
  HOME: '/recruit/v1/candidates',
  CANDIDATES: '/recruit/v1/candidates',
  CANDIDATE_PROFILE: '/recruit/v1/candidates/:id',
};

/**
 * Get the candidate profile route
 *
 * @param {number} candidateId - The candidate ID
 *
 * @returns {string} The candidate profile route
 */
export const getCandidateProfileRoute = (candidateId: number): string => {
  return RECRUIT_ROUTES.CANDIDATE_PROFILE.replace(':id', candidateId.toString());
};

/**
 * Get the candidates list route
 *
 * @returns {string} The candidates list route
 */
export const getCandidatesRoute = (): string => {
  return RECRUIT_ROUTES.CANDIDATES;
};

/**
 * Get the recruit home route
 *
 * @returns {string} The recruit home route
 */
export const getRecruitHomeRoute = (): string => {
  return RECRUIT_ROUTES.HOME;
};

export default RECRUIT_ROUTES;
